import * as yup from 'yup';
export const billSchema = yup.object({
  amount: yup.number().positive().nullable(false).required(),
  attachFile: yup.string().notRequired(),
  commonAreaDeduction: yup.number(),
  date: yup.object().shape({
    startDate: yup.string().required(),
    endDate: yup.string().required()
  }),
  goodWillDeduction: yup.number().test({
    name: 'max',
    test: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return value + this.parent.commonAreaDeduction <= 100;
    }
  }).required()
});